<template>
  <div class="sm-notification-top terms">
    <div class="sm-wrap">
      <div 
        class="sm-notification-top__terms"
        @click="goToTerms"
      >
        <include-svg :name="'icon-no-terms'" />
        <!-- <span>You haven’t upload custom Terms of Service</span> -->
        <a 
          href="#" 
          class="sm-txt-strong"
          @click.prevent
        >Upload your Terms of Service</a>
        <a
          href="#"
          class="sm-notification-top__terms-close"
          @click.stop="closeTerms"
        >
          <include-svg :name="'icon-action-close'" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'terms-notification',
  methods: {
    ...mapActions({
      updateFeatures: 'general/updateFeatures'
    }),
    goToTerms() {
      this.closeTerms();
      
      if (
        this.$route.name != 'admin-settings' ||
        (this.$route.query.tab && this.$route.query.tab != 'company')
      )
        this.$router.push('/admin/settings?terms=1');
    },
    closeTerms() {
      this.updateFeatures({
        terms_of_service_notif: true
      });
      this.$emit('close');
    }
  }
}
</script>